import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import "./scss/bilder.scss";
import "./scss/Header.scss";
import "./scss/Card.scss";
import "./scss/Question.scss";
import "./scss/Button.scss";
import "./scss/Herospace.scss";
import "./scss/Modal.scss";
import "./scss/ProgressIndicator.scss";
import "./scss/SpeechSynthesis.scss";
import "./scss/Footer.scss";
import "./scss/views/startView.scss";
import "./scss/views/gameView.scss";
import "./scss/views/resultView.scss";
import "./scss/mobile/Pagination.scss";
import "./scss/desktop/Playground.scss";

import App from "./App";

import { GameProvider } from "./context/GameContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <GameProvider>
      <App />
    </GameProvider>
  </React.StrictMode>
);
